import React from 'react'
import Grid from '@material-ui/core/Grid'
import ApiRequest from 'EurestoApi/ApiRequest'
import EurestoLogo from 'EurestoStyle/font/euresto_01.png'

const project = require('EurestoConfig/project.config')

export default class extends React.Component {


  async componentDidMount () {
    const result = await ApiRequest(project.api + 'crm', {
      requete: 'contact',
      action: 'unsubscribe',
      key: this.props.params.key
    }, { showAlertError: false })

  }

  render () {
    return (
      <Grid container spacing={0} style={{margin: 0, padding: 0, color: '#393939', fontSize: 15, height: '100vh', textAlign: 'center'}} justify={'center'} alignItems={'center'} alignContent={'center'} direction={'column'}>
        <img style={{ marginTop: 10, maxWidth: 'calc(100vw  - 20px )' }} width="400" src={EurestoLogo}/>
        Vous êtes à présent désabonné de la newsletter Euresto
      </Grid>
    )
  }
}



// WEBPACK FOOTER //
// ./app/App/Module/Page/Page/Unsubscribe/index.js